import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraphQLFormattedError } from 'graphql';
import Modal from '@lib/components/Modal/Modal';
import Form from '@lib/components/ReactHookForm/FormContainer';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { Values } from '@lib/interfaces/form';
import { IconName } from '@lib/components/Modal/enums';
import getAddDomainFormFields, {
  defaultValues,
} from '../../utils/getAddDomainFormFields';

function FormActions(props: { loading?: boolean; onCancel: () => void }) {
  const { loading, onCancel } = props;
  const { t } = useTranslation();
  return (
    <ActionsRow
      actions={[
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          disabled={loading}
          fullWidth
          leftIcon="close"
          onClick={onCancel}
        />,
        <Button
          buttonText={t('add-domain')}
          buttonType={ButtonTypes.primaryFilled}
          fullWidth
          disabled={loading}
          leftIcon="check"
          type="submit"
        />,
      ]}
    />
  );
}

export default function AddDomainModalForm(props: {
  graphQLErrors?: readonly GraphQLFormattedError[];
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (values: Values) => void;
}) {
  const { graphQLErrors, isOpen, loading, onClose, onSubmit } = props;
  const { t } = useTranslation();
  const fields = getAddDomainFormFields({ t });
  return (
    <Modal
      isOpen={isOpen}
      title={t('add-domain')}
      onClose={onClose}
      icon={IconName.DomainVerification}
    >
      <Form
        formId="add-domain"
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        fields={fields}
        actionsComponent={FormActions}
        actionsComponentProps={{ onCancel: onClose }}
        graphQLErrors={graphQLErrors}
        loading={loading}
      />
    </Modal>
  );
}
